<form class="inventory-bulk-edit-form" [formGroup]="bulkEditForm" fxLayout="column"
    fxLayoutAlign="space-around stretch">

    @if (updatedInventories.length > 0 || untouchedInventories.length > 0) {
        <syn-header text="Résumé des modifications"/>
    } @else {
        <syn-header
            text="Édition groupée"
            tooltip="Modification groupée de plusieurs inventaires"
            [caption]="inventoryPluralisation(inventories.length)"
        />
    }

    <mat-stepper #stepper linear>
        <mat-step>
            <div class="form" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
                <div fxLayout="column" fxFlex="100">
                    <div fxLayout="row" fxLayoutAlign="start center" class="syn--margin-top">
                        <mat-checkbox color="primary" formControlName="statusEnabled">
                            Statut
                        </mat-checkbox>
                    </div>
                    <mat-form-field *ngIf="statusEnabled" appearance="outline"
                        subscriptSizing="dynamic" class="syn--margin-top">
                        <mat-label>Statut</mat-label>
                        <mat-select formControlName="status" placeholder="Statut">
                            <mat-option *ngFor="let status of possibleStatus" [value]="status">
                                {{ status }}
                            </mat-option>
                        </mat-select>

                        <mat-hint>Mis à jour dans la limite des restrictions de schémas d'inventaire.</mat-hint>
                    </mat-form-field>

                    <div fxLayout="row" fxLayoutAlign="start center" class="syn--margin-top">
                        <mat-checkbox color="primary" formControlName="serviceTypeEnabled">
                            Type de service
                        </mat-checkbox>
                    </div>
                    <mat-form-field *ngIf="bulkEditForm.get('serviceTypeEnabled').value" appearance="outline"
                        subscriptSizing="dynamic" class="syn--margin-top">
                        <mat-label>Type de service</mat-label>
                        <mat-select formControlName="serviceType" placeholder="Type de service">
                            <mat-option *ngFor="let service of possibleServiceTypes" [value]="service">
                                {{ service }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div fxLayout="row" fxLayoutAlign="start center" class="syn--margin-top">
                        <mat-checkbox color="primary" formControlName="serviceLevelEnabled">
                            Niveau de service
                        </mat-checkbox>
                    </div>

                    @if (project.serviceLevels.length > 0) {
                        <mat-form-field *ngIf="bulkEditForm.get('serviceLevelEnabled').value" appearance="outline"
                        subscriptSizing="dynamic" class="syn--margin-top">
                            <mat-label>Niveau de service</mat-label>
                            <mat-select placeholder="Niveau de service" formControlName="serviceLevel">
                                <mat-select-trigger>
                                    {{ displayServiceLevel(bulkEditForm.get('serviceLevel').value) }}
                                </mat-select-trigger>
                                <mat-option [value]="''">
                                        <div>Non spécifié</div>
                                </mat-option>
                                <mat-option *ngFor="let serviceLevel of project.serviceLevels" [value]="serviceLevel.id">
                                    <div class="service-level">
                                        <div>{{ getUrgencyName(serviceLevel.urgency) }}</div>
                                        <div>{{ getPeriodName(serviceLevel.period) }}</div>
                                    </div>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    } @else {
                        <p class="no-multi-sla">Le multi-SLA n'est pas activé sur le projet</p>
                    }

                    <div fxLayout="row" fxLayoutAlign="start center" class="syn--margin-top">
                        <mat-checkbox color="primary" formControlName="tagsEnabled">
                            Tags
                        </mat-checkbox>
                    </div>

                    <div *ngIf="bulkEditForm.get('tagsEnabled').value" [formGroup]="tagForm">
                        <mat-form-field style="width:100%;" subscriptSizing="dynamic" appearance="outline"
                            class="syn--margin-top">
                            <mat-label>Tag à ajouter</mat-label>

                            <input matInput formControlName="addTag" placeholder="Saisissez des tags"
                                [matChipInputFor]="addTagsChipGrid" (matChipInputTokenEnd)="addNewTag()" />
                            <button matSuffix type="button" mat-icon-button (click)="addNewTag()">
                                <mat-icon svgIcon="plus"></mat-icon>
                            </button>

                            <mat-chip-grid class="mat-chip-grid" #addTagsChipGrid>
                                @for (tag of tagsToAdd; track tag) {
                                <mat-chip-row class="add-chip" (removed)="removeAddTag(tag)">
                                    {{ tag }}
                                    <button matChipRemove aria-label="'remove_' + tag">
                                        <mat-icon svgIcon="close-circle" />
                                    </button>
                                </mat-chip-row>
                                }
                            </mat-chip-grid>
                        </mat-form-field>

                        <mat-form-field style="width:100%;" subscriptSizing="dynamic" appearance="outline"
                            class="syn--margin-top">
                            <mat-label>Tag à supprimer</mat-label>

                            <input matInput formControlName="removeTag" placeholder="Saisissez des tags"
                                [matChipInputFor]="removeTagsChipGrid" (matChipInputTokenEnd)="addRemoveTag()" />

                            <button matSuffix type="button" mat-icon-button (click)="addRemoveTag()">
                                <mat-icon svgIcon="plus"></mat-icon>
                            </button>

                            <mat-chip-grid class="mat-chip-grid" #removeTagsChipGrid>
                                @for (tag of tagsToRemove; track tag) {
                                <mat-chip-row class="remove-chip" (removed)="removeRemoveTag(tag)">
                                    {{ tag }}
                                    <button type="button" matChipRemove aria-label="'remove_' + tag">
                                        <mat-icon svgIcon="close-circle" />
                                    </button>
                                </mat-chip-row>
                                }
                            </mat-chip-grid>
                        </mat-form-field>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="start center" class="syn--margin-top">
                        <mat-checkbox color="primary" formControlName="metadataEnabled">
                            Metadatas
                        </mat-checkbox>
                    </div>

                    <ng-container *ngIf="bulkEditForm.get('metadataEnabled').value">
                        <p class="label syn--margin-top">Ajouts / modifications</p>

                        <form [formGroup]="addMetadataForm" (ngSubmit)="addMetadata()">
                            <table class="metadata">
                                @for (metadata of metadatasToAdd; track metadata) {
                                <tr>
                                    <td>{{ metadata.key }}</td>
                                    <td>{{ metadata.value }}</td>
                                    <td>
                                        <button type="button" mat-icon-button (click)="removeAddMetadata(metadata.key)">
                                            <mat-icon svgIcon="delete-outline"></mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                }
                                <tr class="input">
                                    <td>
                                        <input matInput formControlName="key" placeholder="Clé" />
                                    </td>
                                    <td>
                                        <input matInput formControlName="value" placeholder="Valeur" />
                                    </td>
                                    <td>
                                        <button type="submit" mat-icon-button>
                                            <mat-icon svgIcon="plus"></mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </form>

                        <p class="label syn--margin-top">Suppressions</p>

                        <form [formGroup]="removeMetadataForm" (ngSubmit)="removeMetadata()">
                            <table class="metadata">
                                @for (metadata of metadatasToRemove; track metadata) {
                                <tr>
                                    <td>{{ metadata }}</td>
                                    <td>
                                        <button type="button" mat-icon-button (click)="removeRemoveMetadata(metadata)">
                                            <mat-icon svgIcon="delete-outline"></mat-icon>
                                        </button>
                                    </td>
                                </tr>
                                }
                                <tr class="input">
                                    <td>
                                        <input matInput formControlName="key" placeholder="Clé" />
                                    </td>
                                    <td>
                                        <button type="submit" mat-icon-button>
                                            <mat-icon svgIcon="plus"></mat-icon>
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </form>
                    </ng-container>

                    <div class="action-buttons">
                        <button mat-raised-button (click)="stepper.next()" [disabled]="!hasUpdateParameters" color="accent">Continuer</button>
                        <button mat-flat-button (click)="closePanel()">Annuler</button>
                    </div>
                </div>
            </div>
        </mat-step>

        <mat-step>
            <div class="summary">
                <div class="warning" fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon svgIcon="alert-outline" />
                    <div fxLayout="column">
                        <p class="title">Résumé des modifications</p>
                        <p>Les modifications seront appliquées sur {{ inventoryPluralisation(inventories.length) }}.</p>
                    </div>
                </div>
                <table class="syn--margin-top">
                    <tr *ngIf="statusEnabled">
                        <td>Statut</td>
                        <td>{{ bulkEditForm.get('status').value }}</td>
                    </tr>
                    <tr *ngIf="bulkEditForm.get('serviceTypeEnabled').value">
                        <td>Type de service</td>
                        <td>{{ bulkEditForm.get('serviceType').value }}</td>
                    </tr>
                    <tr *ngIf="bulkEditForm.get('serviceLevelEnabled').value">
                        <td>Niveau de service</td>
                        <td>
                            <div *ngIf="getProjectServiceLevel(bulkEditForm.get('serviceLevel').value) as serviceLevel" class="service-level">
                                <div>{{ getUrgencyName(serviceLevel.urgency) }}</div>
                                <div>{{ getPeriodName(serviceLevel.period) }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr
                        *ngIf="bulkEditForm.get('tagsEnabled').value && (tagsToAdd.length > 0 || tagsToRemove.length > 0)">
                        <td>Tags</td>
                        <td>
                            @if (tagsToAdd.length > 0) {
                                <p>Ajouts</p>
                                <mat-chip-set>
                                    @for (tag of tagsToAdd; track tag) {
                                    <mat-chip class="add-chip">{{ tag }}</mat-chip>
                                    }
                                </mat-chip-set>
                            }
                            @if (tagsToRemove.length > 0) {
                                <p>Suppressions</p>
                                <mat-chip-set>
                                    @for (tag of tagsToRemove; track tag) {
                                    <mat-chip class="remove-chip">{{ tag }}</mat-chip>
                                    }
                                </mat-chip-set>
                            }
                        </td>
                    </tr>
                    <tr
                        *ngIf="bulkEditForm.get('metadataEnabled').value && (metadatasToAdd.length > 0 || metadatasToRemove.length > 0)">
                        <td>Metadatas</td>
                        <td>
                            @if (metadatasToAdd.length > 0) {
                                <p>Ajouts / modifications</p>

                                @for (metadata of metadatasToAdd; track metadata) {
                                    <mat-chip class="add-chip">{{ metadata.key }} : {{ metadata.value }}</mat-chip>
                                }
                            }
                            @if (metadatasToRemove.length > 0) {
                                <p>Suppressions</p>

                                @for (metadata of metadatasToRemove; track metadata) {
                                    <mat-chip class="remove-chip">{{ metadata }}</mat-chip>
                                }
                            }
                        </td>
                    </tr>
                </table>
                <div class="action-buttons">
                    <button mat-flat-button type="button" (click)="submit()">Confirmer</button>
                    <button mat-flat-button type="button" (click)="stepper.previous()">Revenir à l'édition</button>
                </div>
            </div>
        </mat-step>

        <mat-step>
            @if (!loading && (updatedInventories.length > 0 || untouchedInventories.length > 0) && inventoryUpdatedChartData) {
                <div class="pie-chart-container" fxLayout="row" fxLayoutAlign="start center">
                    <div class="pie-chart-graph">
                        <ngx-charts-pie-chart
                            [view]="[120, 120]"
                            [results]="inventoryUpdatedChartData"
                            [scheme]="inventoryUpdatedChartScheme"
                            [animations]="true"
                            [tooltipDisabled]="true">
                        </ngx-charts-pie-chart>
                    </div>

                    <div class="pie-chart-legend" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="legend-color modified"></div>
                            <span>
                                @if (updatedInventories.length > 1) {
                                    {{ updatedInventories.length }} inventaires modifiés
                                } @else {
                                    {{ updatedInventories.length }} inventaire modifié
                                }
                            </span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="legend-color unchanged"></div>
                            <span>
                                @if (untouchedInventories.length > 1) {
                                    {{ untouchedInventories.length }} inventaires inchangés
                                } @else {
                                    {{ untouchedInventories.length }} inventaire inchangé
                                }
                            </span>
                        </div>
                        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <div class="legend-color error"></div>
                            <span>
                                @if (errors.length > 1) {
                                    {{ errors.length }} inventaires en erreur
                                } @else {
                                    {{ errors.length }} inventaire en erreur
                                }
                            </span>
                        </div>
                    </div>
                </div>
            }

            @if (loading) {
            <mat-list>
                @for (inventory of inventories; track inventory) {
                <mat-list-item>
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="label">{{ inventory.name }}</span>
                        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="2" color="primary" />
                    </div>
                </mat-list-item>
                <mat-divider />
                }
            </mat-list>
            } @else {
                <mat-accordion class="summary">
                    @if (updatedInventories.length > 0) {
                        <mat-expansion-panel class="mat-elevation-z0 list-inventory-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                @if (updatedInventories.length > 1) {
                                    <p>{{ updatedInventories.length }} inventaires <b>modifiés</b></p>
                                } @else {
                                    <p>{{ updatedInventories.length }} inventaire <b>modifié</b></p>
                                }
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-list>
                                @for (inventory of updatedInventories; track inventory) {
                                <mat-list-item>
                                    {{ inventory.name }}
                                </mat-list-item>
                                <mat-divider />
                                }
                            </mat-list>
                        </mat-expansion-panel>
                    }

                    @if (untouchedInventories.length > 0) {
                        <mat-expansion-panel class="mat-elevation-z0 list-inventory-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                  @if (untouchedInventories.length > 1) {
                                      <p>{{ untouchedInventories.length }} inventaires <b>inchangés</b></p>
                                  } @else {
                                      <p>{{ untouchedInventories.length }} inventaire <b>inchangé</b></p>
                                  }
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <mat-list>
                                @for (inventory of untouchedInventories; track inventory) {
                                <mat-list-item>
                                    {{ inventory.name }}
                                </mat-list-item>
                                <mat-divider />
                                }
                            </mat-list>
                        </mat-expansion-panel>
                    }

                    @if (errors.length > 0) {
                        <mat-expansion-panel class="mat-elevation-z0 list-inventory-panel">
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                  @if (errors.length > 1) {
                                      <p>{{ errors.length }} inventaires en <b>erreur</b></p>
                                  } @else {
                                      <p>{{ errors.length }} inventaire en <b>erreur</b></p>
                                  }
                              </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ul>
                                @for (error of errors; track error.inventory.id) {
                                <li>
                                    <div fxLayout="column">
                                        <span class="label">{{ error.inventory.name }}</span>
                                        <div class="message">{{ error.error }}</div>
                                    </div>
                                </li>
                                <mat-divider />
                                }
                            </ul>
                        </mat-expansion-panel>
                    }
                </mat-accordion>
            }

            <div class="action-buttons">
                <button mat-flat-button [disabled]="loading" (click)="closePanel()">Fermer</button>
            </div>
        </mat-step>
    </mat-stepper>
</form>